/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown>, unit: NonNullable<unknown> }} Kiotviet_Line_Meta_With_UnitInputs */

const vi_kiotviet_line_meta_with_unit = /** @type {(inputs: Kiotviet_Line_Meta_With_UnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mã KiotViet: ${i?.code} · ĐVT: ${i?.unit}`)
};

/**

* @param {Kiotviet_Line_Meta_With_UnitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_line_meta_with_unit = /** @type {((inputs: Kiotviet_Line_Meta_With_UnitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Line_Meta_With_UnitInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_line_meta_with_unit(inputs)
});